// extracted by mini-css-extract-plugin
export default {"container":"AddHouses_container__O5gWK","add_form":"AddHouses_add_form__6Azzj","form_head":"AddHouses_form_head__8pphk","btn_primary":"AddHouses_btn_primary__TUYTe"};